var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C6.34315 2 5 3.34315 5 5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V5C19 3.34315 17.6569 2 16 2H8ZM15 18.25C15.4142 18.25 15.75 18.5858 15.75 19C15.75 19.4142 15.4142 19.75 15 19.75H9C8.58579 19.75 8.25 19.4142 8.25 19C8.25 18.5858 8.58579 18.25 9 18.25H15ZM7 4.25C7.41421 4.25 7.75 4.58579 7.75 5V14C7.75 14.1381 7.86193 14.25 8 14.25H17C17.4142 14.25 17.75 14.5858 17.75 15C17.75 15.4142 17.4142 15.75 17 15.75H8C7.0335 15.75 6.25 14.9665 6.25 14V5C6.25 4.58579 6.58579 4.25 7 4.25ZM16.5303 8.53033L14.2374 10.8232C13.554 11.5066 12.446 11.5066 11.7626 10.8232L11.1768 10.2374C11.0791 10.1398 10.9209 10.1398 10.8232 10.2374L9.53033 11.5303C9.23744 11.8232 8.76256 11.8232 8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697L9.76256 9.17678C10.446 8.49336 11.554 8.49336 12.2374 9.17678L12.8232 9.76256C12.9209 9.86019 13.0791 9.8602 13.1768 9.76256L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneStat);
export default __webpack_public_path__ + "static/media/smartphone-stat.1eeb92f20ac4edfb7823cadcaf448863.svg";
export { ForwardRef as ReactComponent };